export const isCheckInPhotoCaptureEnabled = ({ room, institution, }) => {
    if (institution?.institutionAccess) {
        return [null, true].includes(institution.institutionAccess.roomFeatures_patientPhotoatCheckIn);
    }
    // Returns true as a default value if no room and institutionAccess
    if (!room) {
        return true;
    }
    return [null, true].includes(room.checkInPhotoCapture);
};
